/** 路由页面类型：用于区分 PC / 小程序 H5 / 移动 H5 等端的登录与跳转逻辑 */
export const PAGE_TYPE = {
  PC: 'pc',
  H5: 'h5',
  MOBILE: 'mobile'
}

/**
 * 从当前匹配链解析页面类型（子路由 meta 优先，其次父级）
 * @param {import('vue-router').Route} route
 * @returns {'pc'|'h5'|'mobile'}
 */
export function getRoutePageType(route) {
  if (!route || !route.matched || !route.matched.length) {
    return PAGE_TYPE.PC
  }
  for (let i = route.matched.length - 1; i >= 0; i--) {
    const pageType = route.matched[i].meta && route.matched[i].meta.pageType
    if (pageType) {
      return pageType
    }
  }
  return PAGE_TYPE.PC
}

/**
 * 按页面类型获取登录页路由名
 * @param {'pc'|'h5'|'mobile'} pageType
 */
export function getLoginRouteByPageType(pageType) {
  switch (pageType) {
    case PAGE_TYPE.H5:
      return 'HoreLogin'
    case PAGE_TYPE.MOBILE:
      return 'MobileLogin'
    case PAGE_TYPE.PC:
    default:
      return 'login'
  }
}

/**
 * 按页面类型获取默认首页路由名
 * @param {'pc'|'h5'|'mobile'} pageType
 */
export function getHomeRouteByPageType(pageType) {
  switch (pageType) {
    case PAGE_TYPE.H5:
      return 'HoreHome'
    case PAGE_TYPE.MOBILE:
      return 'MobileForm'
    case PAGE_TYPE.PC:
    default:
      return 'dashboard'
  }
}
